import {Component, Input, OnDestroy} from '@angular/core';
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {
    AbstractControl, ControlValueAccessor,
    FormBuilder,
    FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors
} from "@angular/forms";
import {Observable, Subscription} from "rxjs";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {map, startWith} from "rxjs/operators";
import {
    arrayIsSet,
    stringIsSet
} from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-form-field-chips',
    templateUrl: './form-field-chips.component.html',
    styleUrls: ['./form-field-chips.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FormFieldChipsComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FormFieldChipsComponent
        }
    ],
    standalone: false
})
export class FormFieldChipsComponent implements ControlValueAccessor, OnDestroy {
    @Input() title: string | undefined
    separatorKeysCodes: number[] = [ENTER, COMMA];
    possibleValues$: Observable<string[]>;
    selectedValues$: Observable<string[] | undefined>;

    possibleValues: string[] = [];

    formGoup: FormGroup
    subscriptions = new Subscription()

    constructor(fb: FormBuilder) {
        this.formGoup = fb.group({
            selectedValues: undefined,
            currentValue: undefined
        })
        this.selectedValues$ = this.formGoup.get('selectedValues')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.selectedValues)
        )
        this.possibleValues$ = this.formGoup.get('currentValue')!.valueChanges.pipe(
            startWith(undefined),
            map((fruit: string | null) => (fruit ? this._filter(fruit) : this.possibleValues.slice())),
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe()
    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const values$ = this.selectedValues$.pipe(
        )
        this.subscriptions.add(
            values$.subscribe(onChange)
        );

    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.formGoup.disable();
        } else {
            this.formGoup.enable();
        }
    }

    writeValue(values: any[]) {
        if (arrayIsSet(values)) {
            setTimeout(() => {
                this.selectedValues = values
            })

        } else {
            this.formGoup.reset()
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // if (!isNotNullOrUndefined(this.form.get('autoComplete')?.validator)) {
        //     this.form.get('autoComplete')?.setValidators(control.validator)
        //     this.form.get('autoComplete')?.updateValueAndValidity()
        // }
        if (this.formGoup.valid) {
            return null
        } else {
            return this.formGoup.errors!;
        }
    }

    addControlErrors(allErrors: any, controlName: string) {
        const errors = {...allErrors};
        const controlErrors = this.formGoup.controls[controlName].errors;
        if (controlErrors) {
            errors[controlName] = controlErrors;
        }
        return errors;
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    get currentValue(): string | undefined {
        return this.formGoup.get('currentValue')?.value
    }

    set currentValue(value) {
        this.formGoup.get('currentValue')?.setValue(value)
    }

    get selectedValues(): string[] | undefined {
        return arrayIsSet(this.formGoup.get('selectedValues')?.value) ? this.formGoup.get('selectedValues')?.value : []
    }

    set selectedValues(value) {
        this.formGoup.get('selectedValues')?.setValue(value)
    }

    add(): void {
        const value = this.currentValue?.trim()
        const selectedValues = arrayIsSet(this.selectedValues) ? [...this.selectedValues] : []
        if (stringIsSet(value)) {
            selectedValues.push(value);
        }
        this.selectedValues = selectedValues;
        setTimeout(() => {
            this.formGoup.get('currentValue')!.reset()
        }, 10)
    }

    remove(fruit: string): void {
        const index = this.selectedValues!.indexOf(fruit);
        if (index >= 0) {
            this.selectedValues!.splice(index, 1);
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        this.selectedValues!.push(event.option.viewValue);
        setTimeout(() => {
            this.formGoup.get('currentValue')!.reset()
        }, 10)
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.possibleValues.filter(fruit => fruit.toLowerCase().includes(filterValue));
    }

    clickAdd() {
        this.add()
    }
}